import Link from "@/modules/LinkOrdemServico/Index.vue";

export default [
  {
    path: "/ordensServicos/:uuid",
    name: "ordensServicos/:uuid",
    component: Link,
    meta: { title: "OS Digital" },
  },
];
